import dticketPauseSubscriptionIcon from './svg/dTicketPauseSubscription.svg?url';

export const DTicketPauseSubscriptionIcon = () => {
	return (
		<img
			src={dticketPauseSubscriptionIcon}
			alt="Pause Deutschlandticket Subscription"
		/>
	);
};
